import React from "react";
import { ISOFilesApi } from "./ISOapi";
import {Link} from "react-router-dom";
import { Helmet } from "react-helmet-async";
const ISOFiles = () => {
  return (
    <>
    <Helmet>
        <title>Download ISO Files for Windows 10, Windows 11 Lite, and Ubuntu</title>
        <meta property="og:title" content="Download ISO Files for Windows 10, Windows 11 Lite, and Ubuntu"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/iso-files"/>
        <meta property="og:description" content=" Download the latest ISO files for Windows 10, Windows 11 Lite, and Ubuntu from our website. Our collection includes the most recent releases of these popular operating systems, all available for free download. With our easy-to-use interface, you can quickly and easily select the ISO file you need and start the download process. Whether you're a student, a professional, or just an everyday user, our website has everything you need to get started with these powerful and versatile operating systems."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>

        <link rel="canonical" href="https://desireStore.online/iso-files" />
        <meta name="title" content="Download ISO Files for Windows 10, Windows 11 Lite, and Ubuntu"/>
        <meta name="description" data-rh="true" content=" Download the latest ISO files for Windows 10, Windows 11 Lite, and Ubuntu from our website. Our collection includes the most recent releases of these popular operating systems, all available for free download. With our easy-to-use interface, you can quickly and easily select the ISO file you need and start the download process. Whether you're a student, a professional, or just an everyday user, our website has everything you need to get started with these powerful and versatile operating systems."/>
        <meta name="keywords" content=" ISO files, Windows 10, Windows 11 Lite, Ubuntu, download, operating systems, free download, latest releases, easy-to-use, interface, versatile."/>
      </Helmet>
      <div className="container">
        <div className="download">
          {ISOFilesApi.map((curElem) => {
            const {
              id,
              Name,
              Image,
              link,
              FullName,
              size,
              Compatibility,
              Developers,
              RAM,
              HardDisk,
              Graphicscard,
              Processor,
            } = curElem;
			
            return (
				
              <div className="col1" key={id}>
				
				<div className="top">
				<img src={Image} alt={Name} />
				<br />
                <Link to={link} download>
                  Download
                </Link>
				</div>
              
                <h3>{Name} - Setup Details</h3>
                <li>Software Full Name : {FullName}</li>
                <li>Setup Size :{size}GB</li>
                <li>Compatibility Mechical : {Compatibility}</li>
                <li>Developers : {Developers}</li>
                <h3>System Requiremenets (Minimum)</h3>
                <li>RAM : {RAM} GB</li>
                <li>Hard Disk :{HardDisk}GB</li>
                <li>System firmware : none</li>
                <li>Graphics card :{Graphicscard}</li>
                <li>Processor : {Processor}</li>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ISOFiles;
